import { Button, Stack, List, ListItem, Typography } from '@mui/material';

import { IconPrinter } from 'src/libraries/icons';

// ----------------------------------------------------------------------

const Instruction: React.FC = () => {
  const handlePrintReport = () => {
    window.print();
  };

  return (
    <Stack
      className="instructionsSection"
      spacing={2}
      sx={{ my: 5, backgroundColor: (theme) => theme.palette.primary.lighter, p: 4 }}
    >
      <Typography>
        To save a copy of your impact report as PDF, please follow the instructions below.
      </Typography>

      <Typography variant="tableHeader">Windows users</Typography>

      <List sx={{ pl: 3, py: 0, listStyleType: 'disc', '& .MuiListItem-root': { py: 0, pl: 0 } }}>
        <ListItem sx={{ display: 'list-item' }}>
          Open the print menu by clicking the “Print report” button below or by pressing Ctrl+P.
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          Under the “Printer” drop-down menu, select “Microsoft Print to PDF” or “Save as PDF”. (The
          exact wording may vary by browser.)
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>Click “Print”.</ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          When prompted, choose where you want to save the file.
        </ListItem>
      </List>

      <Typography variant="tableHeader">Mac users</Typography>

      <List sx={{ pl: 3, py: 0, listStyleType: 'disc', '& .MuiListItem-root': { py: 0, pl: 0 } }}>
        <ListItem sx={{ display: 'list-item' }}>
          Open the print menu by clicking the “Print report” button below or by pressing Command+P.
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          From the PDF drop-down menu (in the lower-left corner), choose “Save as PDF”. (In Chrome
          you may be able to skip this step and select “Open PDF in Preview”.)
        </ListItem>
        <ListItem sx={{ display: 'list-item' }}>
          When prompted, choose where you want to save the file.
        </ListItem>
      </List>

      <Button
        variant="contained"
        onClick={handlePrintReport}
        sx={{ fontSize: 14, py: 2, width: 'fit-content' }}
        endIcon={<IconPrinter size={18} />}
      >
        Print report
      </Button>
    </Stack>
  );
};

export default Instruction;
